<template>
  <Portal>
    <Modal :show="true" @close="close" :clickaway="false" class="action-modal" :data-dropdown-context="dropdownId">
      <Card theme="flat">
        <template #default>
          <div class="card__title row between middle">
            <div>{{ value.name }}</div>
            <component v-if="icon" :is="icon.component" v-bind="icon.props" />
          </div>
          <CustomFields v-model="options" :schema="value.options" :validator="validator" />
        </template>
        <template #footer>
          <ButtonComponent :label="$path('labels.close', value) || $t('cancel')" @click="close" />
          <ButtonComponent
            v-if="value.url"
            :promise="promise"
            :label="$path('labels.confirm', value) || $t('confirm')"
            :icon="['fal', 'arrow-to-right']"
            theme="primary"
            :disabled="!validator.passes"
            :state-timeout="0"
            @click="submit"
          />
        </template>
      </Card>
    </Modal>
  </Portal>
</template>

<script>
import Validator from '@/mixins/validator-v2'

import Card from '@/components/Card'
import Portal from '@/components/Portal'
import { ModalComponent as Modal } from 'vue-elder-modal'
import CustomFields, { getValidatorConfig } from '@kvass/custom-fields'
import { ButtonComponent } from 'vue-elder-button'

export default {
  mixins: [
    Validator({
      labels: 'validatorConfig.labels',
      rules: 'validatorConfig.rules',
      data: 'options',
    }),
  ],
  inject: ['dropdownId'],
  props: {
    value: Object,
    promise: Promise,
  },
  data() {
    return {
      options: {},
    }
  },
  computed: {
    validatorConfig() {
      if (!this.value.options || !this.value.options.length) return {}
      return getValidatorConfig(this.value.options, this.options)
    },
    icon() {
      if (!this.value.icon) return
      if (typeof this.value.icon === 'string') {
        if (this.value.icon.includes('/')) return { component: 'img', props: { src: this.value.icon } }
        return { component: 'FontAwesomeIcon', props: { icon: this.value.icon } }
      }
      if (this.value.icon instanceof Array) return { component: 'FontAwesomeIcon', props: { icon: this.value.icon } }

      return { component: 'FontAwesomeIcon', props: this.value.icon }
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    submit() {
      if (!this.validator.passes) return

      return this.$emit('submit', this.options)
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.options = {}
      },
    },
  },
  components: {
    Card,
    Portal,
    Modal,
    CustomFields,
    ButtonComponent,
  },
}
</script>

<style lang="scss">
.action-modal {
  z-index: 1011 !important;

  .card {
    max-width: 850px;
    min-width: 400px;
  }

  .card__title {
    border-bottom: 1px solid var(--border-color);
    padding-bottom: 1rem;
  }

  .custom-fields {
    gap: 1rem;
    margin-top: 0;
  }
}
</style>
